
/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <div class="calculadora-estructura">

        <div class="seccion-card global-config">
            <div class="card-header-row">
                <strong>Configuración General</strong>
            </div>
            <div class="form-group">
                <label>Material del Techo (Aplica a todas las secciones)</label>
                <select v-model="globalTecho" @change="recalcularTodo">
                    <option value="lamina">Lámina / Metal</option>
                    <option value="concreto">Concreto / Losa</option>
                </select>
            </div>
        </div>

        <div class="actions-header">
            <button type="button" class="btn-add" @click="agregarSeccion">
                <i class="fa-solid fa-plus"></i> Agregar Sección
            </button>
        </div>

        <div v-for="(sec, index) in secciones" :key="index" class="seccion-card">
            <div class="card-header-row">
                <strong>Sección {{ index + 1 }}</strong>

                <div class="badge-soportes" v-if="sec.outputs && sec.outputs.numSoportes > 0"
                    style="font-size: 12px; color: #29b9f6; margin-left: 10px;">
                    <span v-if="sec.estructura === 'tilt'">Soportes: </span>
                    <span v-else>Columnas: </span>
                    <strong>{{ sec.outputs.numSoportes }}</strong>
                </div>

                <button type="button" class="btn-delete" @click="eliminarSeccion(index)" v-if="secciones.length > 0">
                    <i class="fa-solid fa-trash"></i> X
                </button>
            </div>

            <div class="card-body-grid">

                <div class="form-group">
                    <label>Tipo de Estructura</label>
                    <select v-model="sec.estructura" @change="recalcular(index)">
                        <option value="tilt">SIMPLE TILT </option>
                        <option value="coplanar">COPLANAR </option>
                    </select>
                </div>

                <template v-if="sec.estructura === 'tilt'">
                    <div class="form-group">
                        <label>Número de Paneles</label>
                        <input type="number" v-model.number="sec.inputs.numPaneles" @input="recalcular(index)" min="0">
                    </div>
                    <div class="form-group">
                        <label>Altura mínima (m)</label>
                        <input type="number" v-model.number="sec.inputs.altura" @input="recalcular(index)" step="0.1">
                    </div>
                    <div class="form-group">
                        <label>Ángulo (°)</label>
                        <input type="number" v-model.number="sec.inputs.angulo" @input="recalcular(index)">
                    </div>
                </template>

                <template v-else>
                    <div class="form-group">
                        <label>Cols (Largo)</label>
                        <input type="number" v-model.number="sec.inputs.cols" @input="recalcular(index)" min="1">
                    </div>
                    <div class="form-group">
                        <label>Filas (Ancho)</label>
                        <input type="number" v-model.number="sec.inputs.rows" @input="recalcular(index)" min="1">
                    </div>
                    <div class="form-group">
                        <label>Total: {{ (sec.inputs.cols || 0) * (sec.inputs.rows || 0) }}</label>
                    </div>
                </template>
            </div>

            <div class="mini-summary" v-if="panelData">
                <small style="color:#666;">
                    ℹMedidas panel: {{ anchoReal }}m x {{ largoReal }}m
                </small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CalculadoraEstructura',
    props: {
        catalogoMateriales: { type: Array, default: () => [] },
        panelData: { type: Object, default: () => null },
        datosGuardados: { type: [Array, Object], default: () => null }
    },
    data() {
        return {
            secciones: [],
            globalTecho: 'concreto'
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.cargarDatos();
        });
    },

    computed: {
        anchoReal() {
            if (!this.panelData) return 1.15;
            return parseFloat(this.panelData.AnchoMFV);
        },
        largoReal() {
            if (!this.panelData) return 2.20;
            return parseFloat(this.panelData.LargoMFV);
        }
    },
    watch: {
        datosGuardados: {
            deep: true,
            handler(newVal) {
                if (!newVal) return;

                let incomingSecciones = [];
                let incomingTecho = 'concreto';

                if (Array.isArray(newVal)) {
                    incomingSecciones = newVal;
                    if (newVal.length > 0 && newVal[0].techo) incomingTecho = newVal[0].techo;
                } else if (newVal.secciones) {
                    incomingSecciones = newVal.secciones;
                    incomingTecho = newVal.globalTecho || 'concreto';
                }

                const currentLocal = {
                    secciones: this.secciones,
                    globalTecho: this.globalTecho
                };

                const incomingData = {
                    secciones: incomingSecciones,
                    globalTecho: incomingTecho
                };

                if (JSON.stringify(currentLocal) === JSON.stringify(incomingData)) {
                    return;
                }

                this.cargarDatos();
            }
        },

        catalogoMateriales: {
            deep: true,
            handler() {
                if (this.secciones.length > 0) this.recalcularTodo();
            }
        },
        panelData: {
            deep: true,
            handler() {
                if (this.secciones.length > 0) this.recalcularTodo();
            }
        }
    },
    methods: {
        cargarDatos() {
            const val = this.datosGuardados;
            if (!val) {
                if (this.secciones.length === 0) this.agregarSeccion();
                return;
            }

            if (Array.isArray(val)) {
                if (val.length > 0) {
                    this.secciones = JSON.parse(JSON.stringify(val));
                    if (val[0].techo) this.globalTecho = val[0].techo;
                }
            } else if (val.secciones) {
                this.secciones = JSON.parse(JSON.stringify(val.secciones));
                if (val.globalTecho) this.globalTecho = val.globalTecho;
            }

            if (this.secciones.length === 0) this.agregarSeccion();
            this.recalcularTodo();
        },

        agregarSeccion() {
            this.secciones.push({
                estructura: 'tilt',
                inputs: {
                    numPaneles: 0,
                    altura: 0.5,
                    angulo: 15,
                    rows: 1,
                    cols: 1
                },
                outputs: { perfiles: 0, lFoot: 0, tiltConn: 0, connRiel: 0, climber: 0, cross: 0, numSoportes: 0 }
            });
        },

        eliminarSeccion(index) {
            this.secciones.splice(index, 1);
            this.emitirDatos();
        },

        recalcularTodo() {
            this.secciones.forEach((_, i) => this.recalcular(i));
        },

        recalcular(index) {
            const sec = this.secciones[index];
            if (!sec) return;

            const roundUp2 = (num) => Math.ceil(num * 100) / 100;
            const ANCHO_PANEL = this.anchoReal;
            const LARGO_PANEL = this.largoReal;

            let outputPerfiles = 0;
            let outputLFoot = 0;
            let outputTiltConn = 0;
            let outputConnRiel = 0;
            let outputClimber = 0;
            let outputCross = 0;
            let outputTierra = 0;
            let outputNumSoportes = 0;

            if (sec.estructura === 'tilt') {
                const numPaneles = parseInt(sec.inputs.numPaneles) || 0;
                const anguloGrados = parseFloat(sec.inputs.angulo) || 15;
                const alturaMin = parseFloat(sec.inputs.altura) || 0.5;

                if (numPaneles === 0) return;

                const distMaxSoportes = 1.6;
                const panelesPorFila = numPaneles;
                const longitudFila = (panelesPorFila * ANCHO_PANEL);

                const espacios = Math.ceil((longitudFila - 0.6) / distMaxSoportes);
                const numSoportes = espacios + 1;
                outputNumSoportes = numSoportes; 
                const anguloRad = anguloGrados * 0.01745333;
                const separacionLFoot = LARGO_PANEL - 0.7;

                const rawC = separacionLFoot / Math.cos(anguloRad);
                const largoPerfilC = roundUp2(rawC) + 0.10;

                const rawA = Math.sin(anguloRad) * separacionLFoot;
                const largoPerfilA = roundUp2(rawA) + alturaMin;

                const separacionRealSoportes = longitudFila / espacios;
                const largoContraventeoTrasero = roundUp2(Math.sqrt(Math.pow(separacionRealSoportes, 2) + Math.pow(largoPerfilA, 2)));

                const alturaTotalTrasera = largoPerfilA + alturaMin;
                const largoContraventeoLateral = roundUp2(Math.sqrt(Math.pow(separacionLFoot, 2) + Math.pow(alturaTotalTrasera, 2)));

                const metrosSoportes = numSoportes * (largoPerfilC + largoPerfilA);
                const perfilesSoportes = Math.ceil(metrosSoportes / 4.6);

                const metrosRieles = (longitudFila * 2) + ((0.02 * longitudFila) + 1);
                const perfilesMontaje = Math.ceil(metrosRieles / 4.6);

                const metrosAlturaMin = alturaMin * numSoportes;
                const perfilesAlturaMin = Math.ceil(metrosAlturaMin / 4.6);

                const metrosTraseros = 2 * largoContraventeoTrasero;
                const perfilesTraseros = Math.ceil(metrosTraseros / 4.6);

                const metrosLaterales = 2 * largoContraventeoLateral;
                const perfilesLaterales = Math.ceil(metrosLaterales / 4.6);

                const sumaBase = perfilesSoportes + perfilesMontaje + perfilesAlturaMin + perfilesTraseros + perfilesLaterales;
                outputPerfiles = Math.ceil(sumaBase * 1.20); 

                outputLFoot = (numSoportes * 2) + 4;
                outputTiltConn = outputLFoot;
                outputClimber = numSoportes * 2;
                outputCross = (numPaneles * 2) + 2;
                outputTierra = 1;
                

                const unionesPorLinea = Math.ceil((longitudFila + (panelesPorFila * 0.02)) / 4.6);
                outputConnRiel = Math.max(0, (unionesPorLinea - 1) * 2);
            }

            else {
                const cols = parseInt(sec.inputs.cols) || 0; 
                const rows = parseInt(sec.inputs.rows) || 0; 

                if (cols > 0 && rows > 0) {
                    const distMaxSoportes = 1.6;

                    const longitudUnaFila = (cols * ANCHO_PANEL) - 0.6;
                    const metrosRielTotales = (longitudUnaFila/4.6 * 2) ;
                    outputPerfiles = Math.ceil((metrosRielTotales * rows ));

                    const soportesPorLineaDeRiel = Math.ceil(longitudUnaFila / distMaxSoportes) + 1;

                    const totalSoportes = soportesPorLineaDeRiel * 2 * rows;

                    outputLFoot = totalSoportes;
                    outputNumSoportes = totalSoportes; 
                    console.log("outputNumSoportes" , outputNumSoportes);
                    const endClamps = 4 * rows;

                    const midClamps = (cols > 1) ? ((cols - 1) * 2 * rows) : 0;

                    outputCross = endClamps + midClamps;
                    const tierra  = rows;
                    const unionesPorRiel = Math.floor(longitudUnaFila / 4.6);
                    outputConnRiel = unionesPorRiel * 2 * rows;

                    outputTiltConn = 0;
                    outputClimber = 0;
                    outputTierra = tierra;
                }
            }

            sec.outputs = {
                perfiles: outputPerfiles,
                lFoot: outputLFoot,
                tiltConn: outputTiltConn,
                connRiel: outputConnRiel,
                climber: outputClimber,
                cross: outputCross,
                connTierra: outputTierra,
                NumSoportes: outputNumSoportes
            };

            this.emitirDatos();
        },

        emitirDatos() {
            if (!this.catalogoMateriales || this.catalogoMateriales.length === 0) return;

            let consEstructura = {};
            let consAnclaje = {};

            const buscarDatos = (nombre) => {
                if (!nombre) return null;
                const lim = t => t ? t.toString().toLowerCase().trim() : '';
                const buscado = lim(nombre);
                let m = this.catalogoMateriales.find(x => lim(x.Articulo) === buscado);
                if (!m) m = this.catalogoMateriales.find(x => lim(x.Articulo).includes(buscado));
                if (m) return { precio: parseFloat(m.Precio), unidad: m.Unidad, nombreReal: m.Articulo };
                return { precio: 0, unidad: 'Pieza', nombreReal: nombre };
            };

            const agregar = (targetDict, nombre, cantidad) => {
                if (cantidad <= 0) return;
                const d = buscarDatos(nombre);
                const k = d.nombreReal;
                if (!targetDict[k]) targetDict[k] = { cant: 0, cost: d.precio, unit: d.unidad };
                targetDict[k].cant += cantidad;
            };
            let totalTaquetesCalculados = 0;

            this.secciones.forEach(sec => {
                const o = sec.outputs;
                if (!o) return;

                agregar(consEstructura, 'Perfil K2 4.6 m', o.perfiles);
                agregar(consEstructura, 'L-foot', o.lFoot);
                if (sec.estructura === 'tilt') agregar(consEstructura, 'Tilt connector', o.tiltConn);
                agregar(consEstructura, 'Conector de riel', o.connRiel);
                agregar(consEstructura, 'Conector de tierra', o.connTierra );
                if (sec.estructura === 'tilt') agregar(consEstructura, 'Climber set', o.climber);
                agregar(consEstructura, 'Cross clamp', o.cross);

                const puntosAnclaje = (o.NumSoportes * 2);
                totalTaquetesCalculados += puntosAnclaje;

                if (this.globalTecho === 'lamina') {
                    agregar(consAnclaje, 'Pija punta de broca cabeza hexagonal 3/8" x 1 1/2"', puntosAnclaje);
                    agregar(consAnclaje, 'Placa de neopreno 2" x 2"', puntosAnclaje);
                    agregar(consAnclaje, 'Rondana plana', puntosAnclaje);
                    agregar(consAnclaje, 'Rondana de presión', puntosAnclaje);
                } else {
                    agregar(consAnclaje, 'Taquete tipo arpón 3/8" x 3"', puntosAnclaje);
                }
            });
            if (totalTaquetesCalculados > 0) {
                if (this.globalTecho === 'lamina') {
                    const botesSika = Math.ceil(totalTaquetesCalculados / 15);
                    agregar(consAnclaje, 'Sellador SIKA 1A', botesSika);
                } else {
                    const botesEpoxico = Math.ceil(totalTaquetesCalculados / 12);
                    
                    agregar(consAnclaje, 'Sellador epóxico fisher', botesEpoxico);
                }
            }

            const aplicarFactor = (dict) => {
                Object.keys(dict).forEach(k => {
                    const kLow = k.toLowerCase();
                    const esExacto = kLow.includes('cross clamp') || kLow.includes('l-foot') || kLow.includes('tilt connector') || kLow.includes('climber') || kLow.includes('conector de riel') || kLow.includes('conector de tierra') || kLow.includes('perfil');
                    if (!esExacto && !kLow.includes('sellador')) {
                        dict[k].cant = Math.ceil(dict[k].cant);
                    }
                });
            };

            aplicarFactor(consEstructura);
            aplicarFactor(consAnclaje);

            const mapList = (dict) => Object.keys(dict).map(k => ({
                articulo: k,
                unidad: dict[k].unit,
                cantidad: Math.ceil(dict[k].cant),
                costo: dict[k].cost,
                total: Math.ceil(dict[k].cant) * dict[k].cost
            }));

            this.$emit('update-materiales', {
                costoTotal: 0,
                listaEstructura: mapList(consEstructura),
                listaAnclaje: mapList(consAnclaje),
                configuracionInput: {
                    secciones: JSON.parse(JSON.stringify(this.secciones)),
                    globalTecho: this.globalTecho
                }
            });
        }
    },
}
</script>

<style scoped>
.calculadora-estructura {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.global-config {
    border-left: 4px solid #29b9f6;
    background-color: #f8fbff;
}

.actions-header {
    display: flex;
    justify-content: flex-end;
}

.btn-add {
    background: #e3f2fd;
    color: #1565c0;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
}

.seccion-card {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 15px;
}

.card-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;
}

.btn-delete {
    background: none;
    border: none;
    color: #ff5252;
    cursor: pointer;
    font-size: 12px;
}

.card-body-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.form-group label {
    display: block;
    font-size: 11px;
    color: #666;
    margin-bottom: 3px;
}

.info-label {
    font-weight: bold;
    color: #29b9f6;
    margin-top: 15px;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 13px;
}

.mini-summary {
    margin-top: 10px;
    font-size: 11px;
    color: #888;
    border-top: 1px dashed #eee;
    padding-top: 5px;
}
</style>